import type { SVGProps } from "react";

export function CalendarWorkerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ width: "24px", height: "24px" }}
      {...props}
    >
      <title>Worker calendar icon</title>
      {/* Calendar */}
      <rect x="3" y="4" width="15" height="15" rx="2" fill="white" />
      <rect x="3" y="4" width="15" height="15" rx="2" />
      <path d="M3 10h15" />
      <path d="M7 2v4" />
      <path d="M14 2v4" />

      {/* Bubble for user icon */}
      <circle cx="15" cy="15" r="7" fill="white" />
      <circle cx="15" cy="15" r="7" />

      {/* User Icon */}
      <g fill="currentColor" stroke="none">
        <path d="M15 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-3.5 3.5a3.5 3.5 0 0 1 7 0" />
      </g>
    </svg>
  );
}
